<template>
  <q-modal :show="visible" close-button dismissable propagate-events @close="$emit('close')">
    <template #header>
      <span class="text-gray-90 text-lg font-medium">{{ $t('modules.application.shortcuts.title') }}</span>
    </template>

    <ul class="mb-3 flex flex-col gap-3">
      <li v-for="shortcut in shortcuts" :key="shortcut.description" class="flex items-center justify-between">
        <span class="text-gray-70 text-sm">{{ shortcut.description }}</span>
        <ui-key-combo :combo="shortcut.combo" :alternative="shortcut.alternative" />
      </li>
    </ul>
  </q-modal>
</template>

<script setup lang="ts">
import { UiKeyCombo } from '@klausapp/ui-kit'
import QModal from '@/components/QModal.vue'
import keyboardShortcuts from './keyboardShortcuts'

defineProps<{ visible: boolean }>()
const shortcuts = keyboardShortcuts()
</script>
